import { _js } from '@ifixit/localize';
import { Utils } from 'Shared/utils';
// EDITOR MANAGER CLASS
//

export const EditorManager = new Class({
   Implements: [Options, Events],

   options: {
      errorHandler: Utils.ignoreApplicationErrors,
      modifiedHandler: function () {},
   },

   initialize: function (options) {
      this.setOptions(options);
      this.editors = [];
      this.a = 0;
      this.current = null;
      this.modified = false;
      this.errorHandler = this.options.errorHandler;
      this.modifiedHandler = this.options.modifiedHandler;
   },

   register: function (editor) {
      this.editors.push(editor);
   },

   /**
    * Watch a MediaTarget for changes and update this.modified appropriately
    *
    * Ensures that save() will be prevented until attached images are ready.
    */
   watchMediaTarget: function (mediaTarget) {
      mediaTarget.addEvent(
         'fieldUpdated',
         this.getSetModifiedFunction(() => {
            let item = mediaTarget.mediaItem;
            if (item && !item.isReady()) {
               throw new ApplicationError(
                  _js('All images must be finished processing before saving')
               );
            }
         })
      );
   },

   /**
    * Registers a minimal 'editor' with the given onSave() callback [optional]
    *
    * Returns: a function that when called, changes the registered editor's
    * modified state to true.
    */
   getSetModifiedFunction: function (onSave) {
      let self = this;
      // Mock an editor and add it the collection.
      let editor = {
         save: onSave,
      };
      this.register(editor);
      return function () {
         editor.modified = true;
         self.updateModified();
      };
   },

   beginEditMode: function () {
      let args = Array.convert(arguments);
      let editor = args.shift();

      try {
         if (this.current !== null) {
            this.current.endEditMode();
         }
         editor.beginEditMode.apply(editor, args);
         this.current = editor;
      } catch (e) {
         this.errorHandler(e);
      }
   },

   endEditMode: function () {
      if (this.current === null) {
         return;
      }

      try {
         this.current.endEditMode();
         this.current = null;
         this.updateModified();
      } catch (e) {
         this.errorHandler(e);
      }
   },

   updateModified: function () {
      let modified = false;
      this.editors.each(editor => {
         modified = modified || editor.modified;
      });
      if (modified !== this.modified) {
         this.modified = modified;
         this.modifiedHandler(modified);
      }
   },

   save: function (onComplete) {
      try {
         if (this.current !== null) {
            this.current.endEditMode();
            this.current = null;
            this.updateModified();
         }
         Array.each(this.editors, editor => {
            editor.save && editor.save();
         });
         onComplete();
      } catch (e) {
         this.errorHandler(e);
      }
   },
});
